import { Component, OnDestroy, OnInit } from '@angular/core';
import { ApiGetAccountParams } from 'app/models/clients/account/api-get-account-params.model';
import { Account } from 'app/models/funds/account.model';
import { AccountSelectorService } from 'app/services/account/account-selector.service';
import { PartyService } from 'app/services/party/party.service';
import { of, ReplaySubject, Subscription } from 'rxjs';
import { catchError, takeUntil } from 'rxjs/operators';

@Component({
  selector: 'account-selector',
  templateUrl: './account-selector.component.html',
  styleUrls: ['./account-selector.component.scss']
})
export class AccountSelectorComponent implements OnInit, OnDestroy {

  accountsArray: any = [
    {
      currencyCode: '',
      accountId: '',
      balance: '0.00',
      financialInstitutionDetails: {
        countryCode : '' 
       },
     }
  ];

  selectedAccountIndex = 0;
  updatedAccountFetched = false;
  destroyed$ = new ReplaySubject<void>(1);

  constructor(private accountSelectorService: AccountSelectorService, private partyService: PartyService) { }

  ngOnInit(): void {
    this.initiateAccountsArray(this.selectedAccountIndex);
    this.listenForUpdate();
    this.initAccountSelection();
  }

  ngOnDestroy(): void {
    this.destroyed$.next();
    this.destroyed$.complete();
  }

  fireSelectedAccount(accountIndex): void {
    console.log("Selected Account changed to: ", this.accountsArray[accountIndex]);
    this.accountSelectorService.notifyAccountChange(this.accountsArray[accountIndex]);
  }

  // index parameter is used for selecting a specific account as the selected (first/default) option after fetching the accounts. 
  initiateAccountsArray(index: number): void {
    this.partyService.getAccounts({buckzyAccountCategory: 'Main', size: 9999, page: 0}).subscribe(response => {
      this.accountsArray = response?.content;

      if (this.accountsArray?.length > 0) {
        this.accountSelectorService.notifyAccountChange(this.accountsArray[index]);
        this.updatedAccountFetched = true;
      } else {
        console.log("partyService.getAccounts() returned an empty response body!");
      }
    }, err => {
      console.log(err);
    });
  }

  listenForUpdate() {
    this.accountSelectorService.accountUpdateRequested().subscribe(accountId => {
      if (accountId) {
        this.updatedAccountFetched = false;

        // finding the index of updated acount object by accountId
        let index = this.accountsArray.findIndex( acc => acc.accountId == accountId );
        if (index) {
          this.initiateAccountsArray(index);
        } else {
          // if for some reason couldn't find the specific account index then pass the first account index, i.e. 0.
          this.initiateAccountsArray(0);
        }
       }
    });
  }

  initAccountSelection(): void {
    this.accountSelectorService.getSelectedAccount().pipe(
      catchError(error => of({} as Account)),
      takeUntil(this.destroyed$),
    ).subscribe(account => {
      if (account) {
        let index = this.accountsArray.findIndex( acc => acc.accountId == account.accountId );
        if (index) {
          this.selectedAccountIndex = index;
        } else {
          // if for some reason couldn't find the specific account index then pass the first account index, i.e. 0.
          this.selectedAccountIndex = 0;
        }
      }
    }, err => {
    });
  }

}
